export const formatMessageTime = (timestamp) => {
  if (!timestamp || typeof timestamp !== 'string') return null;
  // Backend stores UTC without 'Z' suffix - add it for proper timezone conversion
  const utcTimestamp = timestamp.endsWith('Z') ? timestamp : timestamp + 'Z';
  const msgDate = new Date(utcTimestamp);
  // Check for invalid date
  if (isNaN(msgDate.getTime())) return null;
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterday = new Date(today.getTime() - 86400000);
  const msgDay = new Date(msgDate.getFullYear(), msgDate.getMonth(), msgDate.getDate());

  const timeStr = msgDate.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  });

  if (msgDay.getTime() === today.getTime()) {
    return timeStr;
  } else if (msgDay.getTime() === yesterday.getTime()) {
    return `Yesterday ${timeStr}`;
  } else {
    const dateStr = msgDate.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric'
    });
    return `${dateStr} ${timeStr}`;
  }
};

export const shouldShowTimestamp = (currentMsg, prevMsg) => {
  if (!currentMsg?.timestamp || typeof currentMsg.timestamp !== 'string') return false;
  if (!prevMsg?.timestamp || typeof prevMsg.timestamp !== 'string') return true; // First message in chat

  // Backend stores UTC without 'Z' suffix - add it for proper timezone conversion
  const currentTs = currentMsg.timestamp.endsWith('Z') ? currentMsg.timestamp : currentMsg.timestamp + 'Z';
  const prevTs = prevMsg.timestamp.endsWith('Z') ? prevMsg.timestamp : prevMsg.timestamp + 'Z';
  const current = new Date(currentTs);
  const prev = new Date(prevTs);

  // Check for invalid dates
  if (isNaN(current.getTime()) || isNaN(prev.getTime())) return false;

  const diffMinutes = Math.abs(current - prev) / (1000 * 60);

  // Show timestamp if gap > 30 minutes OR different day
  return diffMinutes > 30 || current.toDateString() !== prev.toDateString();
};
